import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { sessionsKeys } from "@/features/sessions/queries/sessionsQueryKeys";
import bookingService, {
    type RescheduleSessionInput,
    type RescheduleSessionResult,
} from "@/features/sessions/services/bookingService";

export function useRescheduleSession() {
    const queryClient = useQueryClient();

    const mutation = useMutation<RescheduleSessionResult, Error, RescheduleSessionInput>({
        mutationFn: async (input) => {
            return bookingService.rescheduleSession(input);
        },
        onError: (error) => {
            const message = error instanceof Error ? error.message : "Failed to update session date. Please try again.";
            toast.error(message);
        },
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({ queryKey: sessionsKeys.attendance.session(variables.sessionId) });
            queryClient.invalidateQueries({ queryKey: sessionsKeys.sessions.detail(variables.sessionId) });
            queryClient.invalidateQueries({ queryKey: sessionsKeys.sessions.all() });
            toast.success("Session date updated");
        },
    });

    return {
        error: mutation.error,
        isError: mutation.isError,
        isPending: mutation.isPending,
        mutate: mutation.mutate,
        mutateAsync: mutation.mutateAsync,
    };
}
